export function getFormUrl(): string {
  return 'https://readdy.ai/api/form/d9rgq2ue3oq4jqumu16g';
}